import { Injectable } from '@angular/core';
import { FirebaseApp, getApp, getApps, initializeApp } from 'firebase/app';
import { Firestore, getFirestore } from 'firebase/firestore';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FirebaseFactoryService {
  private static app: FirebaseApp | null = null;
  private static firestoreInstance: Firestore | null = null;

  public getFirebaseApp(): FirebaseApp {
    if (!FirebaseFactoryService.app) {
      const apps = getApps();
      if (apps.length === 0) {
        FirebaseFactoryService.app = initializeApp(environment.firebase);
      } else {
        FirebaseFactoryService.app = getApp();
      }
    }
    return FirebaseFactoryService.app;
  }

  public getFirestoreInstance(): Firestore {
    if (!FirebaseFactoryService.firestoreInstance) {
      const app = this.getFirebaseApp();
      FirebaseFactoryService.firestoreInstance = getFirestore(app);
    }
    return FirebaseFactoryService.firestoreInstance;
  }

  public static resetInstances(): void {
    FirebaseFactoryService.app = null;
    FirebaseFactoryService.firestoreInstance = null;
  }
}